import React from 'react';
import PropTypes from 'prop-types';
import PersonaIcon from './PersonaIcon';
const PersonaIcons = (props) => {
  const personaList = Object.values(props.personas).map((persona, i) => (
    <div
      key={persona.id}
      className="slds-size_1-of-1"
      style={{ padding: '5px' }}
    >
      <PersonaIcon
        imgURL={persona.picUrl}
        name={persona.name}
        id={persona.id}
        size="large"
        index={i}
      />
    </div>
  ));

  return <div className="slds-grid slds-wrap">{personaList}</div>;
};

PersonaIcons.propTypes = {
  personas: PropTypes.object.isRequired,
};

export default PersonaIcons;
